import React, { useContext, useEffect, useState } from "react";

import {
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  FormControlLabel,
  Icon,
  Switch,
} from "@material-ui/core";

import SearchIcon from "@material-ui/icons/Search";

import TextFieldErp from "../../../../components/basics/TextFieldErp";
import SelectErp from "../../../../components/basics/SelectErp";
import Card from "../../../../components/cards/Card";
import { Margin } from "../../../../theme/styles/Utils";

import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";

import { FontButton, HeaderModal } from "../styles/Emissao";

import { MinClienteContext } from "../contexts/MinClienteContext";
import useEmissaoMinClienteController from "../controllers/EmissaoMinClienteController";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import { findPais } from "../../../../repository/ERP/prouser/PaisService";
import { findMunicipio } from "../../../../repository/ERP/prouser/MunicipioService";
import { findEstado } from "../../../../repository/ERP/prouser/EstadoService";

const ModalEmissaoCadastroCliente = ({ open, setOpen }) => {
  const { queryParams } = useContext(QueryParamsContext);

  const {
    generalCustomerId,
    generalTypeSubscription,
    generalName,
    setGeneralName,
    generalFantasy,
    setGeneralFantasy,
    generalCep,
    setGeneralCep,
    generalAddress,
    setGeneralAddress,
    generalNumber,
    setGeneralNumber,
    generalComplement,
    setGeneralComplement,
    generalDistrict,
    setGeneralDistrict,
    generalUf,
    setGeneralUf,
    generalCounty,
    setGeneralCounty,
    generalNation,
    setGeneralNation,
    generalTelephone1,
    setGeneralTelephone1,
    generalTelephone2,
    setGeneralTelephone2,
    generalTelephone3,
    setGeneralTelephone3,
    generalEmail,
    setGeneralEmail,
    generalRg,
    setGeneralRg,
    generalIe,
    setGeneralIe,
    generalSimpleNational,
    setGeneralSimpleNational,
    generalFinalCustomer,
    setGeneralFinalCustomer,
    generalMatriz,
    generalIm,
    setGeneralIm,
    generalCheckBudget,
    setGeneralCheckBudget,
    generalCheckNfe,
    setGeneralCheckNfe,
    generalCheckFinancial,
    setGeneralCheckFinancial,
    generalActive,
    setGeneralActive,
    setGeneralSendEmail,
    generalDateInitial,
    setGeneralDateInitial,
    generalIeIndication,
    setGeneralIeIndication,
    generalWebsite,
    setGeneralWebsite,
    generalSendEmail,
    generalCpfCnpj,
    setGeneralCpfCnpj,
    listUf,
    setListUf,
    listCounty,
    setListCounty,
    listNation,
    setListNation,
    loadingInputs,
    setLoadingInputs,
    errors,
  } = useContext(MinClienteContext);

  const {
    handleChangeCpfCnpj,
    handleChangeCep,
    handleChangeUf,
    handleCreateMinCliente,
    clearAccordionCadastroCliente,
  } = useEmissaoMinClienteController();

  // eslint-disable-next-line
  const [searchMatrizOpen, setSearchMatrizOpen] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        setLoadingInputs((current) => ({
          ...current,
          listNation: true,
        }));
        const resultNation = await findPais(queryParams.empresa_cnpj);

        if (resultNation.success) {
          setListNation(resultNation.data);
          setGeneralNation(
            resultNation.data.find((nation) => nation.codigo === "1058") || null
          );
        }
      } catch (error) {
      } finally {
        setLoadingInputs((current) => ({
          ...current,
          listNation: false,
        }));
      }
    })();
  }, [
    queryParams.empresa_cnpj,
    setGeneralNation,
    setListNation,
    setLoadingInputs,
  ]);

  useEffect(() => {
    (async () => {
      try {
        setLoadingInputs((current) => ({
          ...current,
          listCounty: true,
        }));

        const resultCounty = await findMunicipio(queryParams.empresa_cnpj);
        if (resultCounty.success) setListCounty(resultCounty.data);
      } catch (error) {
      } finally {
        setLoadingInputs((current) => ({
          ...current,
          listCounty: false,
        }));
      }
    })();
  }, [queryParams.empresa_cnpj, setListCounty, setLoadingInputs]);

  useEffect(() => {
    (async () => {
      try {
        setLoadingInputs((current) => ({
          ...current,
          listUf: true,
        }));
        const resultUf = await findEstado(queryParams.empresa_cnpj);
        if (resultUf.success) setListUf(resultUf.data);
      } catch (error) {
      } finally {
        setLoadingInputs((current) => ({
          ...current,
          listUf: false,
        }));
      }
    })();
  }, [queryParams.empresa_cnpj, setListUf, setLoadingInputs]);

  let valid = false;

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Dialog
      fullWidth={true}
      maxWidth="md"
      open={open}
      onClose={handleClose}
      aria-labelledby="dialog-cadastro-rapido-cliente"
    >
      <HeaderModal>
        <DialogTitle id="dialog-cadastro-rapido-cliente">
          <Chip
            label="CADASTRO RÁPIDO DE CLIENTE"
            bgcolor="primary"
            textcolor="white"
          />
        </DialogTitle>
      </HeaderModal>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item lg={3} sm={6} xs={12}>
            <TextFieldErp
              disabled={
                generalTypeSubscription && !generalCustomerId ? false : true
              }
              error={errors.generalCpfCnpj ? true : false}
              helperText={errors.generalCpfCnpj || ""}
              label={`CPF ou CNPJ*`}
              value={generalCpfCnpj}
              setValue={setGeneralCpfCnpj}
              onBlur={(e) => {
                handleChangeCpfCnpj(e, "general");
              }}
              InputProps={{
                endAdornment: <SearchIcon onClick={() => {}} />,
              }}
            />
          </Grid>

          <Grid item lg={5} sm={6} xs={12}>
            <TextFieldErp
              error={errors.generalName ? true : false}
              helperText={errors.generalName || ""}
              label={`${
                generalTypeSubscription &&
                generalTypeSubscription.value === "cpf"
                  ? "Nome"
                  : "Razão Social"
              }*`}
              maxLength={50}
              value={generalName}
              setValue={setGeneralName}
            />
          </Grid>

          <Grid item lg={4} sm={6} xs={12}>
            <TextFieldErp
              error={errors.generalFantasy ? true : false}
              helperText={errors.generalFantasy || ""}
              label={`${
                generalTypeSubscription &&
                generalTypeSubscription.value === "cpf"
                  ? "Apelido"
                  : "Fantasia"
              }*`}
              maxLength={20}
              value={generalFantasy}
              setValue={setGeneralFantasy}
            />
          </Grid>

          <Grid item lg={3} sm={6} xs={12}>
            <TextFieldErp
              error={errors.generalCep ? true : false}
              helperText={errors.generalCep || ""}
              label="CEP*"
              maxLength={10}
              value={generalCep}
              setValue={setGeneralCep}
              onChange={(value) => handleChangeCep(value, "general")}
              mask="cep"
              InputProps={{
                endAdornment: <SearchIcon onClick={() => {}} />,
              }}
            />
          </Grid>

          <Grid item lg={6} sm={6} xs={6}>
            <TextFieldErp
              error={errors.generalAddress ? true : false}
              helperText={errors.generalAddress || ""}
              label="Endereço*"
              maxLength={120}
              value={generalAddress}
              setValue={setGeneralAddress}
            />
          </Grid>

          <Grid item lg={2} sm={6} xs={12}>
            <TextFieldErp
              error={errors.generalNumber ? true : false}
              helperText={errors.generalNumber || ""}
              label="Número"
              maxLength={10}
              value={generalNumber}
              setValue={setGeneralNumber}
            />
          </Grid>

          <Grid item lg={3} sm={6} xs={12}>
            <TextFieldErp
              label="Complemento"
              maxLength={60}
              value={generalComplement}
              setValue={setGeneralComplement}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldErp
              error={errors.generalDistrict ? true : false}
              helperText={errors.generalDistrict || ""}
              label="Bairro*"
              maxLength={60}
              value={generalDistrict}
              setValue={setGeneralDistrict}
            />
          </Grid>

          <Grid item lg={3} md={2} sm={6} xs={12}>
            <SelectErp
              error={errors.generalNation ? true : false}
              helperText={errors.generalNation || ""}
              loading={loadingInputs.listNation || false}
              label="País*"
              value={generalNation}
              setValue={setGeneralNation}
              optionsList={listNation}
              descriptionField="descricao"
            />
          </Grid>

          <Grid item lg={2} md={3} sm={6} xs={12}>
            <SelectErp
              error={errors.generalUf ? true : false}
              helperText={errors.generalUf || ""}
              loading={loadingInputs.listUf || false}
              label="Estado*"
              value={generalUf}
              onChange={(e) =>
                handleChangeUf(e, setGeneralUf, setGeneralCounty)
              }
              optionsList={listUf}
              descriptionField="estado"
            />
          </Grid>

          <Grid item lg={4} md={4} sm={6} xs={12}>
            <SelectErp
              error={errors.generalCounty ? true : false}
              helperText={errors.generalCounty || ""}
              loading={loadingInputs.listCounty || false}
              label="Municipio*"
              value={generalCounty}
              setValue={setGeneralCounty}
              optionsList={
                generalUf
                  ? listCounty.filter(
                      (opt) => opt.estado_codigo === generalUf.codibge
                    )
                  : listCounty
              }
              descriptionField="municipio"
            />
          </Grid>

          {generalTypeSubscription && generalTypeSubscription.value === "cpf" && (
            <Grid item lg={3} md={3} sm={6} xs={12}>
              <TextFieldErp
                label="RG"
                value={generalRg}
                setValue={setGeneralRg}
              />
            </Grid>
          )}

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldErp
              error={errors.generalTelephone1 ? true : false}
              helperText={errors.generalTelephone1 || ""}
              label="Telefone 1"
              value={generalTelephone1}
              setValue={setGeneralTelephone1}
              mask="cel-phone"
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldErp
              error={errors.generalTelephone2 ? true : false}
              helperText={errors.generalTelephone2 || ""}
              label="Telefone 2"
              value={generalTelephone2}
              setValue={setGeneralTelephone2}
              mask="cel-phone"
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldErp
              error={errors.generalTelephone3 ? true : false}
              helperText={errors.generalTelephone3 || ""}
              label="Telefone 3"
              value={generalTelephone3}
              setValue={setGeneralTelephone3}
              mask="cel-phone"
            />
          </Grid>

          <Grid item lg={5} md={3} sm={6} xs={12}>
            <TextFieldErp
              label="Inscrição municipal"
              maxLength={15}
              value={generalIm}
              setValue={setGeneralIm}
            />
          </Grid>

          {generalTypeSubscription &&
            generalTypeSubscription.value === "cnpj" &&
            valid && (
              <Grid item lg={3} md={3} sm={6} xs={12} container spacing={1}>
                <Grid item xs>
                  <TextFieldErp
                    variant="filled"
                    disabled
                    label="Matriz"
                    error={errors.generalMatriz ? true : false}
                    helperText={errors.generalMatriz || ""}
                    value={generalMatriz ? generalMatriz.apelido || "" : ""}
                  />
                </Grid>

                <Grid item flex={1}>
                  <Btn
                    height="48px"
                    onClick={() => {
                      setSearchMatrizOpen(true);
                    }}
                    label={<Icon>search</Icon>}
                  />
                </Grid>
              </Grid>
            )}

          <Grid item lg={5} md={3} sm={6} xs={12}>
            <SelectErp
              loading={false}
              label="Indicação de IE"
              value={generalIeIndication}
              setValue={setGeneralIeIndication}
              optionsList={[
                { label: "Contribuinte ICMS", value: 1, codigo: "1" },
                { label: "Contribuinte Isento", value: 0, codigo: "2" },
                { label: "Não Contribuinte", value: 0, codigo: "9" },
              ]}
              descriptionField="label"
            />
          </Grid>

          {generalIeIndication && generalIeIndication.value ? (
            <Grid item lg={3} md={3} sm={6} xs={12}>
              <TextFieldErp
                label="IE"
                maxLength={20}
                value={generalIe}
                setValue={setGeneralIe}
              />
            </Grid>
          ) : (
            <></>
          )}

          <Grid item lg={2} md={3} sm={6} xs={12}>
            <TextFieldErp
              label="Cliente Desde"
              maxLength={50}
              defaultValue=""
              value={generalDateInitial}
              setValue={setGeneralDateInitial}
              type="date"
            />
          </Grid>

          <Grid item lg>
            <TextFieldErp
              label="Site"
              maxLength={50}
              value={generalWebsite}
              setValue={setGeneralWebsite}
            />
          </Grid>
          <Grid item>
            <FormControlLabel
              value="end"
              control={
                <Switch
                  checked={generalFinalCustomer}
                  onChange={() =>
                    setGeneralFinalCustomer((current) => !current)
                  }
                  color="primary"
                />
              }
              label="Consumidor Final"
              labelPlacement="end"
            />
          </Grid>
          <Grid item>
            <FormControlLabel
              control={
                <Switch
                  checked={generalActive}
                  onChange={() => setGeneralActive((current) => !current)}
                  color="primary"
                />
              }
              label="Ativo"
              labelPlacement="end"
            />
          </Grid>

          {generalTypeSubscription && generalTypeSubscription.value === "cnpj" && (
            <Grid item xs={12}>
              <FormControlLabel
                value="end"
                control={
                  <Switch
                    checked={generalSimpleNational}
                    onChange={() =>
                      setGeneralSimpleNational((current) => !current)
                    }
                    color="primary"
                  />
                }
                label="Optante pelo simples nacional"
                labelPlacement="end"
              />
            </Grid>
          )}

          <Margin top="90" />
          <Grid item container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card label="Configuração de Email">
                <Grid container spacing={2}>
                  <Grid item lg={12} xs={12}>
                    <TextFieldErp
                      label="E-mail"
                      maxLength={60}
                      value={generalEmail}
                      setValue={setGeneralEmail}
                    />
                  </Grid>
                  <Grid item>
                    <FormControlLabel
                      value="end"
                      control={
                        <Switch
                          checked={generalCheckNfe}
                          onChange={() =>
                            setGeneralCheckNfe((current) => !current)
                          }
                          color="primary"
                        />
                      }
                      label="NF-e"
                      labelPlacement="end"
                    />
                  </Grid>

                  <Grid item>
                    <FormControlLabel
                      value="end"
                      control={
                        <Switch
                          checked={generalCheckFinancial}
                          onChange={() =>
                            setGeneralCheckFinancial((current) => !current)
                          }
                          color="primary"
                        />
                      }
                      label="Financeiro"
                      labelPlacement="end"
                    />
                  </Grid>

                  <Grid item>
                    <FormControlLabel
                      value="end"
                      control={
                        <Switch
                          checked={generalCheckBudget}
                          onChange={() =>
                            setGeneralCheckBudget((current) => !current)
                          }
                          color="primary"
                        />
                      }
                      label="Orçamento/Venda"
                      labelPlacement="end"
                    />
                  </Grid>

                  <Grid item sm={5}>
                    <FormControlLabel
                      value="end"
                      control={
                        <Switch
                          checked={generalSendEmail}
                          onChange={() =>
                            setGeneralSendEmail((current) => !current)
                          }
                          color="primary"
                        />
                      }
                      label="Enviar e-mail de notificação de contas a vencer"
                      labelPlacement="end"
                    />
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <FontButton>
          <Grid container spacing={2}>
            <Grid item lg></Grid>
            <Grid item>
              <Btn
                label="Cadastrar"
                onClick={() => {
                  handleCreateMinCliente(setOpen);
                }}
              />
            </Grid>
            <Grid item>
              <Btn
                bgcolor="tertiary"
                hovercolor="blue"
                onClick={() => {
                  handleClose();
                  clearAccordionCadastroCliente();
                }}
                label="Cancelar"
              />
            </Grid>
          </Grid>
        </FontButton>
      </DialogActions>
    </Dialog>
  );
};

export default ModalEmissaoCadastroCliente;
